var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.list),function(item,index){return _c('leave-list-item',_vm._b({key:`${item.leaveId}-${item.personId}`,attrs:{"student":item,"showbb":_vm.showbb && index < _vm.list.length - 1},on:{"click":_vm.handlerClickItem,"clickBack":_vm.handlerClickBack}},'leave-list-item',_vm.$props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }